export default function (input) {
    return JSON.parse(JSON.stringify(input))
}
